module.exports = __webpack_public_path__ + "img/avatar_random_19.90278174.png";